"use strict";
jQuery.fn.outerhtml = function() {
    var o = jQuery(this).clone().detach().wrap('<div>').parent(),
        s = o.html();
    o.remove();
    return s;
};
